<template>
  <div>
    <!-- <div>fieldId: {{ field.fieldId }}</div> -->
    <!-- <div>value: {{ field.value }}</div> -->
    <!-- <pre class="language-json"><code>DriverFields: {{ driverFields  }}</code></pre> -->
    <b-row>
      <b-col class="fields-workflow">
        <ValidationProvider
          cols="7"
          :name="getFieldIdInputName"
          rules="required"
          v-slot="{ validate, passed }"
        >
          <div :class="[{ 'has-success': passed }]">
            <b-col cols="7">
              <label for="getFieldIdInputName" v-if="field.type != '9'">
                <b-row>
                  <b-col cols="12" md="auto">{{ field.fieldName }}</b-col>
                  <b-col class="required" v-if="field.required">*</b-col>
                </b-row>
              </label>
              <b-input-group>
                <!-- Boolean -->
                <base-imput-logic
                  v-if="field.type == 1"
                  :options="optionsBoolean"
                  :value.sync="field.value"
                ></base-imput-logic>
                <!-- Data -->
                <b-form-input
                  v-if="field.type == 2"
                  type="date"
                  :id="getFieldIdInputName"
                  :placeholder="field.fieldTip"
                  v-model="field.value"
                  @input="calculateDate"
                />
                <!-- Hora -->
                <b-form-input
                  v-if="field.type == 3"
                  type="time"
                  :id="getFieldIdInputName"
                  :placeholder="field.fieldTip"
                  v-model="field.value"
                  @input="calculateDate"
                />
                <!-- Decimal -->
                <b-form-input
                  v-if="field.type == 4"
                  type="text"
                  :id="getFieldIdInputName"
                  :placeholder="field.fieldTip"
                  v-model="field.value"
                  v-mask="'money'"
                  @input="validate"
                />
                <!-- Inteiro -->
                <b-form-input
                  v-if="field.type == 5"
                  type="text"
                  :id="getFieldIdInputName"
                  :placeholder="field.fieldTip"
                  v-model="field.value"
                  v-mask="'999999999999999'"
                  @input="validate"
                />
                <!-- Texto -->
                <b-form-input
                  v-if="field.type == 6"
                  type="text"
                  :id="getFieldIdInputName"
                  :placeholder="field.tip"
                  v-model="field.value"
                  @input="validate"
                />
                <!-- Lista -->
                <single-select
                  v-if="field.type == 7"
                  :value.sync="field.value"
                  :value-property="'value'"
                  :options="options"
                  id="perPageSelect"
                >
                </single-select>
                <!-- Lista Integração -->
                <!-- Lista Integração -->
                <select-integration-list
                  v-if="field.type >= 9000 && field.type != 9024"
                  id="perPageSelect"
                  :fieldId="field.fieldId"
                  :value.sync="field.value"
                  :selected-value.sync="field.selectedValue"
                >
                </select-integration-list>

                <b-form-input
                  v-if="field.type == 9024"
                  type="text"
                  :id="getFieldIdInputName"
                  :placeholder="field.fieldTip"
                  v-model="field.value"
                  disabled
                />
                <b-input-group-append
                  v-if="field.type == 9024"
                  lg="6"
                  md="6"
                  sm="12"
                >
                  <div class="file">
                    <b-button
                      size="sm"
                      :title="$t('geral.details')"
                      @click="$refs.tripDriveModal.openModal()"
                    >
                      <i>
                        <b-icon icon="search" aria-hidden="true"></b-icon>
                      </i>
                    </b-button>
                  </div>
                  <trip-drive-modal
                    ref="tripDriveModal"
                    :driverFields.sync="driverFields"
                  ></trip-drive-modal>
                </b-input-group-append>

                <!-- {{ options }} -->
                <!-- Apenas Anexo -->
                <b-input-group-append
                  v-if="field.type == 10"
                  lg="6"
                  md="6"
                  sm="12"
                >
                  <div>
                    <div class="div-attachment-only">
                      <camera-button
                        :lang="$i18n.locale"
                        :imageSrc="field.attachment"
                        :originObject="field"
                        @update-image-src="updateImageSrc"
                      >
                      </camera-button>
                    </div>
                  </div>

                  <b-form-group
                    label=""
                    class="fileOnlyAttachment"
                    label-cols-sm="-2"
                  >
                    <b-form-file
                      :lang="$i18n.locale"
                      id="fileOnlyAttachment"
                      ref="file"
                      :placeholder="$t('geral.escolhaArquivo')"
                      v-on:change="handleFileUpload($event, field)"
                      :no-drop="true"
                    >
                    </b-form-file>
                  </b-form-group>
                </b-input-group-append>

                <!-- Assinatura -->
                <b-input-group-append
                  v-else-if="field.type == 11"
                  lg="6"
                  md="6"
                  sm="12"
                >
                  <b-button
                    type="button"
                    @click.prevent="
                      $refs.fullscreenSidebar.open();
                      $refs.assinatura.show();
                    "
                    size="sm"
                    style="border-radius: 0.4285rem"
                  >
                    <span
                      class="icon"
                      style="font-family: Helvetica, Arial, sans-serif"
                    >
                      <i class="tim-ncil"> </i> Adicionar Assinatura
                    </span>
                  </b-button>
                </b-input-group-append>
                <!-- QRCode -->
                <b-form-input
                  v-if="field.type == 12"
                  @input="validate"
                  type="text"
                  :id="getFieldIdInputName"
                  :placeholder="field.fieldTip"
                  v-model="field.value"
                />
                <!-- objetivo -->
                <base-imput-logic
                  class="ml-0"
                  v-if="field.type == 13"
                  :options="options"
                  :value.sync="field.value"
                ></base-imput-logic>

                <!-- cnpj -->
                <b-form-input
                  v-if="field.type == 15"
                  @input="validate"
                  type="text"
                  :id="getFieldIdInputName"
                  :placeholder="field.fieldTip"
                  v-model="field.value"
                  v-mask="'99.999.999/9999-99'"
                />
                <!-- cnpj filial-->
                <b-form-input
                  v-if="field.type == 16"
                  @input="validate"
                  type="text"
                  :id="getFieldIdInputName"
                  :placeholder="field.fieldTip"
                  v-model="field.value"
                  v-mask="'99.999.999/9999-99'"
                />
                <!-- CPF -->
                <b-form-input
                  v-if="field.type == 17"
                  @input="validate"
                  type="text"
                  :id="getFieldIdInputName"
                  :placeholder="field.fieldTip"
                  v-model="field.value"
                  v-mask="'999.999.999-99'"
                />
                <!-- TextArea -->
                <b-form-textarea
                  v-if="field.type == 18"
                  @input="validate"
                  :id="getFieldIdInputName"
                  :placeholder="field.fieldTip"
                  v-model="field.value"
                />
                <!-- Anexos -->
                <b-input-group-append
                  v-else-if="field.allowAttachment"
                  lg="6"
                  md="6"
                  sm="12"
                >
                  <div>
                    <div class="div-attachment-photo">
                      <camera-button-append
                        :imageSrc="field.attachment"
                        :originObject="field"
                        @update-image-src="updateImageSrc"
                      >
                      </camera-button-append>
                    </div>
                  </div>
                  <label class="file">
                    <b-form-file
                      class="tim-icons icon-attach-87"
                      style="width: 0%; padding: 27%; display: none"
                      :lang="$i18n.locale"
                      :placeholder="$t('')"
                      v-on:change="handleFileUpload($event, field)"
                      :no-drop="true"
                    />
                    <span class="icone">
                      <i
                        class="tim-icons icon-attach-87"
                        style="padding-top: 25%; margin-left: 15px"
                      ></i
                    ></span>
                  </label>
                </b-input-group-append>

                <!-- responsável -->
                <b-form-select
                  v-if="field.type == 14"
                  v-model="field.value"
                  track-by="text"
                  id="perPageSelect"
                  :options="allUsers"
                ></b-form-select>

                <!-- Plano de viagem -->

                <select-integration-list
                  v-if="field.type == 19"
                  id="perPageSelect"
                  :fieldId="field.fieldId"
                  :value.sync="field.value"
                  :selected-value.sync="field.selectedValue"
                >
                </select-integration-list>

                <!-- veículos -->
                <single-select
                  v-if="field.type == 20"
                  :value.sync="field.value"
                  :value-property="'value'"
                  :options="vehicles"
                  id="perPageSelect"
                >
                </single-select>

                <!-- Motoristas -->
                <single-select
                  v-if="field.type == 21"
                  :value.sync="field.value"
                  :value-property="'value'"
                  :options="drivers"
                  id="perPageSelect"
                >
                </single-select>

                <!-- Checklist ID-->
                <b-form-input
                  v-if="field.type == 1000"
                  @input="validate"
                  type="text"
                  :id="getFieldIdInputName"
                  :placeholder="field.fieldTip"
                  v-model="field.value"
                  :readonly="true"
                />
                <b-input-group-append
                  v-if="field.type == 1000 && field.id != 0"
                  class="file"
                >
                  <b-button
                    size="sm"
                    :title="$t('geral.details')"
                    @click="$refs.checklistDetails.open()"
                  >
                    <i>
                      <b-icon icon="eye" aria-hidden="true"></b-icon>
                    </i>
                  </b-button>
                  <pendency-field-details-modal
                    ref="checklistDetails"
                    :id="field.value"
                  ></pendency-field-details-modal>
                </b-input-group-append>

                <!-- Workflow Process ID-->
                <b-form-input
                  v-if="field.type == 1001"
                  @input="validate"
                  type="text"
                  :id="getFieldIdInputName"
                  :placeholder="field.fieldTip"
                  v-model="field.value"
                  readonly
                />
              </b-input-group>

              <!-- {{ selected }} -->
              <!-- {{ field }} -->

              <b-row class="text-center" v-if="field.attachments != null">
                <b-col
                  md="12"
                  v-for="(attachment, i) in field.attachments"
                  :key="i"
                >
                  <base-attachment-viewer
                    class="ml-3 mb-3"
                    :attachment="attachment"
                    :discard-visible="true"
                    :attachments.sync="field.attachments"
                    @discard="fileRemove"
                  ></base-attachment-viewer>
                </b-col>
              </b-row>
              <div v-else-if="field.allowAttachment">
                <div class="frame pt-3 pb-3 mb-3">
                  <img
                    :src="field.attachment"
                    class="mx-auto d-block"
                    style="width: 200px; height: 200px"
                  />
                  <div style="padding-left: 40%">
                    <b-button
                      v-on:click="removeAttachment(field.attachment)"
                      variant="link"
                      id="btn-remover"
                      class="link"
                    >
                      Remover
                    </b-button>
                  </div>
                </div>
              </div>
              <span class="text-danger">
                {{ getProblemText() }}
              </span>
            </b-col>
          </div>
        </ValidationProvider>
      </b-col>
    </b-row>

    <!-- campos adicionais -->
    <div
      v-for="additionalField in getListAdditionalField()"
      :key="additionalField.fieldId"
    >
      <workflow-fill-field
        :field="additionalField"
        :fieldId="additionalField.fieldId"
        :modelstate="modelstate"
        :stage="false"
      >
      </workflow-fill-field>
    </div>

    <fullscreen-sidebar
      ref="fullscreenSidebar"
      @onHide="$refs.assinatura.hide()"
      @onShown="$refs.assinatura.show()"
    >
      <template v-slot:content>
        <b-container>
          <base-signature
            ref="assinatura"
            @update-image-src="updateValueImageSrc"
          >
          </base-signature>
        </b-container>
      </template>
    </fullscreen-sidebar>
    <!-- <div><pre class="language-json"><code>{{ tripPlan  }}</code></pre></div> -->
    <!-- <div><pre class="language-json"><code>{{ field  }}</code></pre></div> -->
    <!-- <div><pre class="language-json"><code>modelstate: {{ modelstate  }}</code></pre></div> -->

    <!-- <div v-if="field.type == 7">
      <div>{{ options }}</div>
    </div> -->
    <!-- <div><pre class="language-json"><code>{{ field  }}</code></pre></div>  -->
  </div>
</template>
<script>
import { extend } from "vee-validate";
import { required, email, min } from "vee-validate/dist/rules";
extend("required", required);
import AwesomeMask from "awesome-mask";
import { forceClassName } from "@fullcalendar/core";
import SelectIntegrationList from "../integrations/SelectIntegrationList.vue";
export default {
  name: "WorkflowFillField",
  props: {
    field: Object,
    fieldId: String,
    readonly: Boolean,
    modelstate: Object,
    trip: Object,
    driverFields: Array,
    dateEnd: String,
  },
  components: {
    BaseImputLogic: () => import("@/components_rms/base/BaseImputLogic.vue"),
    FullscreenSidebar: () => import("@/components_rms/FullscreenSidebar.vue"),
    BaseSignature: () => import("@/components_rms/base/BaseSignature.vue"),
    CameraButton: () => import("@/components_rms/CameraButton.vue"),
    CameraButtonAppend: () => import("@/components_rms/CameraButtonAppend.vue"),
    BaseAttachmentViewer: () =>
      import("@/components_rms/base/BaseAttachmentViewer.vue"),
    "pendency-field-details-modal": () =>
      import("@/pagesRms/checklist/pendency/PedencyFieldDetailsModal.vue"),
    SingleSelect: () => import("@/components_rms/base/SingleSelect.vue"),
    SelectIntegrationList: () =>
      import("@/components_rms/integrations/SelectIntegrationList.vue"),
    "workflow-fill-field": () =>
      import("@/components_rms/workflow/WorkflowFillField.vue"),
    tripDriveModal: () =>
      import("@/components_rms/workflow/ShLog/TripDriveModal.vue"),
    FormFillFieldTypeList: () =>
      import("@/components_rms/checklist/form/FormFillFieldTypeList.vue"),
  },
  directives: {
    mask: AwesomeMask,
  },
  created() {
    switch (this.field.type) {
      case 7:
        this.getOptions();
        break;
      case 13:
        this.getOptions();
        break;
      case 14:
        this.getUsers();
        break;
      case 19:
        this.getOptions();
        break;
      case 20:
        this.getVehicles();
        break;
      case 21:
        this.getDrivers();
        break;
    }
    this.tripPlan = this.trip;
  },
  computed: {
    getFieldIdInputName() {
      return "input" + this.fieldId.toString();
    },
    hasProblem() {
      if (this.getProblemText().length > 0) {
        return true;
      }
      return false;
    },
  },
  data() {
    return {
      optionsBoolean: [
        { value: "true", text: "Sim" },
        { value: "false", text: "Não" },
      ],
      options: [],
      allUsers: [],
      vehicles: [],
      drivers: [],
      fieldOpt: { value: "", text: "" },
      tripPlan: {},
      tripName: "",
      selected: null,
    };
  },
  methods: {
    shDriver(field) {
      console.log(field);
    },
    calcDateEnd() {
      let hour = this.tripPlan.timeTotal.split(":")[0];
      let minutes = this.tripPlan.timeTotal.split(":")[1];
      let diasStr = (hour / 24).toString();
      let dias = diasStr.split(".")[0];
      for (let i = 0; i < dias; i++) {
        hour = hour - 24;
      }
      let hBegin = this.tripPlan.hourBegin.split(":")[0];
      hour = hour + parseInt(hBegin);
      if (hour > 24) {
        dias++;
        hour = hour - 24;
      }
      let ano = parseInt(this.tripPlan.dateBegin.split("-")[0]);
      let mes = parseInt(this.tripPlan.dateBegin.split("-")[1]);
      let dia = parseInt(this.tripPlan.dateBegin.split("-")[2]);

      if (dias != 0) {
        for (let i = 0; i < dias; i++) {
          if (
            mes == 1 ||
            mes == 3 ||
            mes == 5 ||
            mes == 7 ||
            mes == 8 ||
            mes == 10 ||
            mes == 12
          ) {
            if (dia == 30) {
              dia = 1;
              if (mes == 12) {
                mes = 1;
                ano++;
              } else mes++;
            } else dia++;
          } else if (mes == 4 || mes == 6 || mes == 9 || mes == 11) {
            if (dia == 30) {
              dia = 1;
              mes++;
            } else dia++;
          } else {
            if (dia == 29) {
              mes++;
              dia = 1;
            } else dia++;
          }
        }
      }
      if (mes < 10) mes = "0" + mes;
      if (dia < 10) dia = "0" + dia;
      let dateFinal = ano + "-" + mes + "-" + dia;
      this.tripPlan.dateEnd = dateFinal;
      this.$emit("update:trip", this.tripPlan);
      this.$emit("new-value");
      this.$forceUpdate();
    },
    calcHourEnd() {
      let hour = parseInt(this.tripPlan.timeTotal.split(":")[0]);
      let minutes = parseInt(this.tripPlan.timeTotal.split(":")[1]);
      let diasStr = (hour / 24).toString();
      let dias = diasStr.split(".")[0];
      for (let i = 0; i < dias; i++) {
        hour = hour - 24;
      }
      let hBegin = this.tripPlan.hourBegin.split(":")[0];
      hour = hour + parseInt(hBegin);

      let mBegin = this.tripPlan.hourBegin.split(":")[1];
      minutes = minutes + parseInt(mBegin);

      if (minutes >= 60) {
        minutes = minutes % 60;
        hour++;
      }
      if (hour > 24) {
        hour = hour - 24;
      }
      if (hour == 24) hour = 0;

      if (minutes < 10) minutes = "0" + minutes;
      if (hour < 10) hour = "0" + hour;
      let hourTotal = hour + ":" + minutes;

      this.tripPlan.hourEnd = hourTotal;
      this.$emit("new-value");
      this.$emit("update:trip", this.tripPlan);
    },
    calcDateBegin() {
      let hour = this.tripPlan.timeTotal.split(":")[0];
      let diasStr = (hour / 24).toString();
      let dias = diasStr.split(".")[0];
      for (let i = 0; i < dias; i++) {
        hour = hour - 24;
      }
      let hEnd = this.tripPlan.hourEnd.split(":")[0];
      hour = hour + parseInt(hEnd);
      if (hour > 24) {
        dias++;
      }
      let ano = parseInt(this.tripPlan.dateEnd.split("-")[0]);
      let mes = parseInt(this.tripPlan.dateEnd.split("-")[1]);
      let dia = parseInt(this.tripPlan.dateEnd.split("-")[2]);

      if (dias != 0) {
        for (let i = 0; i < dias; i++) {
          if (dia == 1) {
            if (
              mes == 1 ||
              mes == 3 ||
              mes == 5 ||
              mes == 7 ||
              mes == 8 ||
              mes == 10 ||
              mes == 12
            ) {
              dia = 30;
              if (mes == 1) {
                dia = 31;
                ano--;
              } else if (mes == 3) {
                dia = 29;
              }
            } else if (mes == 4 || mes == 6 || mes == 9 || mes == 11) {
              dia = 31;
            }
            mes--;
          } else {
            dia--;
          }
        }
      }
      if (mes < 10) mes = "0" + mes;
      if (dia < 10) dia = "0" + dia;
      let dateFinal = ano + "-" + mes + "-" + dia;
      this.tripPlan.dateBegin = dateFinal;
      this.$emit("new-value");
      this.$emit("update:trip", this.tripPlan);
    },
    calcHourBegin() {
      let hour = parseInt(this.tripPlan.timeTotal.split(":")[0]);
      let minutes = parseInt(this.tripPlan.timeTotal.split(":")[1]);
      let init = parseInt(this.tripPlan.timeTotal.split(":")[0]);
      let diasStr = (hour / 24).toString();
      let dias = diasStr.split(".")[0];
      let time = 0;
      for (let i = 0; i < dias; i++) {
        hour = hour - 24;
      }

      let hBegin = this.tripPlan.hourEnd.split(":")[0];
      if (hour == 24) hour = parseInt(hBegin);
      else if (hour == 0) {
        let hBegin = this.tripPlan.hourEnd.split(":")[0];
        hour = hour + parseInt(hBegin);
      } else {
        time = 24 - hour;
        hour = parseInt(hBegin) + time;
      }

      let mBegin = this.tripPlan.hourEnd.split(":")[1];
      minutes = parseInt(minutes) + parseInt(mBegin);

      if (init == 0 && minutes < 60) {
        minutes = minutes % 60;
        hour--;
      } else if (minutes >= 60) {
        minutes = minutes % 60;
        console.log(minutes);
      }

      if (minutes < 10) minutes = "0" + minutes;
      if (hour < 10) hour = "0" + hour;
      let hourTotal = hour + ":" + minutes;

      this.tripPlan.hourBegin = hourTotal;
      this.$emit("new-value");
      this.$emit("update:trip", this.tripPlan);
    },
    calculateDate() {
      if (this.field.isTripPlanDateBegin) {
        this.tripPlan.dateBegin = this.field.value;
        this.$emit("update:trip", this.tripPlan);
        this.$forceUpdate();
      } else if (this.field.isTripPlanHourBegin) {
        this.tripPlan.hourBegin = this.field.value;
        this.$emit("update:trip", this.tripPlan);
        this.$forceUpdate();
      } else if (this.field.isTripPlanDateEnd) {
        this.tripPlan.dateEnd = this.field.value;
        this.$emit("update:trip", this.tripPlan);
        this.$forceUpdate();
      } else if (this.field.isTripPlanHourEnd) {
        this.tripPlan.hourEnd = this.field.value;
        this.$emit("update:trip", this.tripPlan);
        this.$forceUpdate();
      }
      if (
        this.tripPlan.dateBegin != "" &&
        this.tripPlan.hourBegin != "" &&
        this.tripPlan.timeTotal != ""
      ) {
        this.calcDateEnd();
        this.calcHourEnd();
      } else if (
        this.tripPlan.dateEnd != "" &&
        this.tripPlan.hourEnd != "" &&
        this.tripPlan.timeTotal != ""
      ) {
        this.calcDateBegin();
        this.calcHourBegin();
      }
    },
    getListAdditionalField() {
      let fields = [];
      if (this.field.valueList != null) {
        for (let opt of this.field.valueList) {
          if (opt.id == this.field.value) {
            if (opt.values != null) {
              for (let aditionalField of opt.values) {
                fields.push(aditionalField);
              }
            }
          }
        }
      }
      return fields;
    },
    getUsers() {
      this.$apiWorkflow
        .get(`/field/responsible/${this.fieldId}`)
        .then((response) => {
          this.allUsers = response.data;
        });
    },
    getVehicles() {
      this.$apiWorkflow
        .get(`/field/vehicles/${this.fieldId}`)
        .then((response) => {
          this.vehicles = response.data;
        });
    },
    getDrivers() {
      this.$apiWorkflow.get(`/list/drivers/`).then((response) => {
        this.drivers = response.data;
      });
    },
    getOptions() {
      this.field.valueList.forEach((item) => {
        if (this.field.value != "" && this.field.type == "20") {
          if (this.field.value == item.id) {
            this.fieldOpt.value = item.id;
            this.fieldOpt.text = item.text;
          }
        }
        // console.log(item);
        this.options.push({
          value: item.id,
          text: item.text,
        });
      });
    },
    getProblemText() {
      // console.log(this.fieldId)
      if (this.modelstate) {
        let modelstateText = this.modelstate[this.fieldId.toString()];
        if (modelstateText) {
          return modelstateText.toString();
        }
      }
      return "";
    },
    getTrip() {
      this.$apiWorkflow
        .get(`/tripPlan/getTrip/${this.fieldOpt.value}`)
        .then((response) => {
          // let time = response.data.totalSecondsEntered;
          let time = response.data.totalSecondsEntered;
          let totalTime = "";
          let hour = Math.floor(time / 3600);
          let minutes = Math.floor((time % 3600) / 60);
          if (hour < 10) hour = "0" + hour;
          if (minutes < 10) minutes = "0" + minutes;
          totalTime = hour + ":" + minutes;
          this.tripPlan.timeTotal = totalTime;
          this.$emit("update:trip", this.tripPlan);
          this.$forceUpdate();
        });
    },
    handleFileUpload(event, object) {
      // console.log("object");
      // console.log(object);
      const fileElement = event.target;
      const file = fileElement.files[0];
      const reader = new FileReader();
      reader.addEventListener(
        "load",
        () => {
          // convert image file to base64 string
          object.attachments.push({
            attachment: reader.result,
            attachemntName: "",
          });
          object.attachment = "";
          // this.onDataChange(object);
        },
        false
      );
      if (file) {
        reader.readAsDataURL(file);
      }
    },
    updateImageSrc(originObject, newValue) {
      originObject.attachments.push({ attachment: newValue });
      originObject.attachment = "";
      // this.onDataChange(originObject);
      this.$forceUpdate();
    },
    updateValueImageSrc(newValue) {
      this.field.attachments.push({ attachment: newValue });
      this.field.attachment = "";
      // this.onDataChange(this.value);
      this.$forceUpdate();
      this.$refs.fullscreenSidebar.close();
    },
    onChangeFieldValue(value) {
      console.log(value);
      if (value) {
        this.field.value = value.value;
      } else {
        this.field.value = "";
      }
      if (this.field.type == 19) {
        if (this.tripName == "") this.tripName = this.field.value;
        else {
          if (this.tripName != this.field.value) {
            this.tripName = this.field.value;
            this.tripPlan.dateBegin = "";
            this.tripPlan.dateEnd = "";
            this.tripPlan.hourBegin = "";
            this.tripPlan.hourEnd = "";
            this.$emit("update:trip", this.tripPlan);
            this.$emit("new-value");
            this.$forceUpdate();
          }
        }
      }
      // this.onDataChange(this.value);
    },
    removeAttachment(anexo) {
      console.log(anexo);
      this.field.attachments.splice(anexo, 1);
      // this.onDataChange(this.value);
      this.$forceUpdate();
    },
    fileRemove(attachment) {
      console.log(attachment);
      this.field.attachments.forEach((item) => {
        if (attachment.id == item.id) {
          let index = this.field.attachments.indexOf(item);
          this.field.attachments.splice(index, 1);
        }
        // this.onDataChange(this.field);
        this.$forceUpdate();
      });
    },
  },
  watch: {
    fieldOpt() {
      this.getTrip();
    },
  },
};
</script>
<style scope>
.required {
  color: #fd5d93;
  margin-left: -13px !important;
}

.div-attachment-file {
  display: block;
}

.div-attachment-photo {
  display: none;
}

.div-attachment-only {
  display: none;
}

.fileOnlyAttachment {
  border: 1px;
  width: 498px;
  height: 35px;
  border-top-right-radius: 8px !important;
  border-bottom-right-radius: 8px !important;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}

#btn-remover .link:hover {
  /* background-color: green !important; */
  color: black !important;
}

.frame {
  /* display: block; */
  border: solid 1px;
  /* width: 315px;
  height: 250px; */
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}

.frameDesk {
  border: solid 1px;
  width: 100%;
  /* height: 250px; */
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}

.file {
  background: #2c3b5d;
  width: 3rem;
  height: 38px;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  border: none;
}

.fields-workflow {
  margin-left: -15px;
}

.btn_eye {
  border-top-right-radius: 8px;
}

@media (max-width: 768px) {
  .div-attachment-file {
    display: none;
  }

  .div-attachment-photo {
    display: block;
    margin-top: -1.5rem;
  }

  .file {
    display: none;
  }

  .fileOnlyAttachment {
    display: none;
  }

  .div-attachment-only {
    display: block;
    margin-top: -1.5rem;
  }

  .frameDesk {
    display: none;
  }
}
</style>
